import { isPlatformBrowser } from '@angular/common';
import { Component, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { GlobalLoader } from './core/loading/global-loader/global-loader';
import { LoadingService } from './core/loading/loading.service';
import { SeoService } from './core/services/seo.service';
import { ToastComponent } from './core/toast/toast.component';
import { FundCalculatorApi } from './personal-fund-request/services/fund-calculator-api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoader, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit, OnDestroy {
  private readonly seo = inject(SeoService);
  private readonly loading = inject(LoadingService);
  private readonly fundCalculatorApi = inject(FundCalculatorApi);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private initialLoadFallbackTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly completeInitialPageLoad = (): void => {
    this.loading.completeInitialPageLoad();

    if (this.initialLoadFallbackTimer) {
      clearTimeout(this.initialLoadFallbackTimer);
      this.initialLoadFallbackTimer = null;
    }
  };

  ngOnInit(): void {
    void this.seo;

    if (!this.isBrowser) {
      return;
    }

    this.fundCalculatorApi.preloadOptions();

    if (document.readyState === 'complete') {
      window.requestAnimationFrame(this.completeInitialPageLoad);
      return;
    }

    window.addEventListener('load', this.completeInitialPageLoad, { once: true });
    this.initialLoadFallbackTimer = setTimeout(this.completeInitialPageLoad, 8000);
  }

  ngOnDestroy(): void {
    if (!this.isBrowser) {
      return;
    }

    window.removeEventListener('load', this.completeInitialPageLoad);

    if (this.initialLoadFallbackTimer) {
      clearTimeout(this.initialLoadFallbackTimer);
    }
  }
}
